import axios from "axios";

const security_key = "86b432bb2871216fca5739395a276391";
const themeDefault = "dark";
const namesOfModes = ["dark", "moonlight", "eclipse", "light"];

const BASE_URL = "https://emstylemsk.net/";

const options_salutation = [
    { value: "Mr", label: "Mr" },
    { value: "Ms", label: "Ms" },
    { value: "Dr", label: "Dr" },
];

const options_paymen_frequecy = [
    { value: "", label: "---Select---" },
    { value: "Weekly", label: "Weekly" },
    { value: "Fortnightly", label: "Fortnightly" },
    { value: "Monthly", label: "Monthly" },
    ``,
];

const options_countries = [];

const options_patient = [];

const fetchPatientOption = async () => {
    try {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllPatient",
        });

        const output = response.data;

        // console.log("Response Data:", output);

        if (output.length > 0) {
            const formattedOptions = output.map((option) => ({
                value: option.pk_patient_id,
                label: `${option.patient_first_name} ${option.patient_last_name}-${option.patient_mobile_phone}-${option.patient_email}`,
            }));

            options_patient.push(...formattedOptions);

            // console.log(options_patient);
        } else {
            // Handle error or show an alert message
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

fetchPatientOption();

const options_provider = [];

const fetchProviderOption = async () => {
    try {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllProvider",
        });

        const output = response.data;

        // console.log("Response Data:", output);

        if (output.length > 0) {
            const formattedOptions = output.map((option) => ({
                value: option.pk_provider_id,
                label: `${option.provider_first_name} ${option.provider_last_name}`,
            }));

            options_provider.push(...formattedOptions);

            // console.log(options_provider);
        } else {
            // Handle error or show an alert message
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

fetchProviderOption();

const options_city = [
    /* { value: "New York City || 40.7128, -74.006", label: "Afghanistan" },*/
];

const options_state = [
    /* { value: "New York City || 40.7128, -74.006", label: "Afghanistan" },*/
];

const fetchData = async () => {
    try {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllCity",
        });

        // alert(response.data.length);

        if (response.data.length > 0) {
            const formattedOptions = response.data.map((option) => ({
                // value: option.pk_city_id,
                value: `${option.pk_city_id} || ${option.City} || ${option.State}`,
                label: option.City,
            }));

            const formattedOptions2 = response.data.map((option) => ({
                // value: option.pk_city_id,
                value: `${option.pk_city_id} || ${option.City} || ${option.State}`,
                label: option.State,
            }));

            options_city.push(...formattedOptions);
            options_state.push(...formattedOptions2);
        } else {
            // Handle error or show an alert message
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

fetchData();

const options_label = [];
const options_status = [];

const getAllStatus = async () => {
    try {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllStatus",
        });

        const output = response.data;

        // console.log("Response Data:", output);

        if (response.data.length > 0) {
            const formattedOptions1 = response.data.map((option) => option.status);

            const formattedOptions2 = response.data.map((option) => ({
                value: option.pk_status_id,
                label: option.status,
            }));

            options_label.push(...formattedOptions1);
            options_status.push(...formattedOptions2);
        } else {
            // Handle error or show an alert message
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

getAllStatus();

const loadCityOptions = async (inputValue) => {
    try {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getSearchCities",
            search: inputValue,
        });

        return response.data; // Expecting: [{ label: 'City Name', value: 'city_id' }, ...]
    } catch (error) {
        console.error("Error fetching cities:", error);
        return [];
    }
};
const loadZipOptions = async (inputValue) => {
    try {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getSearchZips",
            search: inputValue,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching cities:", error);
        return [];
    }
};

const options_countries1 = [
    { value: "AF", label: "Afghanistan" },
    { value: "AX", label: "Åland Islands" },
    { value: "AL", label: "Albania" },
    { value: "DZ", label: "Algeria" },
    { value: "AS", label: "American Samoa" },
    { value: "AD", label: "Andorra" },
    { value: "AO", label: "Angola" },
    { value: "AI", label: "Anguilla" },
    { value: "AQ", label: "Antarctica" },
    { value: "AG", label: "Antigua and Barbuda" },
    { value: "AR", label: "Argentina" },
    { value: "AM", label: "Armenia" },
    { value: "AW", label: "Aruba" },
    { value: "AU", label: "Australia" },
    { value: "AT", label: "Austria" },
    { value: "AZ", label: "Azerbaijan" },
    { value: "BS", label: "Bahamas" },
    { value: "BH", label: "Bahrain" },
    { value: "BD", label: "Bangladesh" },
    { value: "BB", label: "Barbados" },
    { value: "BY", label: "Belarus" },
    { value: "BE", label: "Belgium" },
    { value: "BZ", label: "Belize" },
    { value: "BJ", label: "Benin" },
    { value: "BM", label: "Bermuda" },
    { value: "BT", label: "Bhutan" },
    { value: "BO", label: "Bolivia, Plurinational State of" },
    { value: "BQ", label: "Bonaire, Sint Eustatius and Saba" },
    { value: "BA", label: "Bosnia and Herzegovina" },
    { value: "BW", label: "Botswana" },
    { value: "BV", label: "Bouvet Island" },
    { value: "BR", label: "Brazil" },
    { value: "IO", label: "British Indian Ocean Territory" },
    { value: "BN", label: "Brunei Darussalam" },
    { value: "BG", label: "Bulgaria" },
    { value: "BF", label: "Burkina Faso" },
    { value: "BI", label: "Burundi" },
    { value: "KH", label: "Cambodia" },
    { value: "CM", label: "Cameroon" },
    { value: "CA", label: "Canada" },
    { value: "CV", label: "Cape Verde" },
    { value: "KY", label: "Cayman Islands" },
    { value: "CF", label: "Central African Republic" },
    { value: "TD", label: "Chad" },
    { value: "CL", label: "Chile" },
    { value: "CN", label: "China" },
    { value: "CX", label: "Christmas Island" },
    { value: "CC", label: "Cocos (Keeling) Islands" },
    { value: "CO", label: "Colombia" },
    { value: "KM", label: "Comoros" },
    { value: "CG", label: "Congo" },
    { value: "CD", label: "Congo, the Democratic Republic of the" },
    { value: "CK", label: "Cook Islands" },
    { value: "CR", label: "Costa Rica" },
    { value: "CI", label: "Côte d'Ivoire" },
    { value: "HR", label: "Croatia" },
    { value: "CU", label: "Cuba" },
    { value: "CW", label: "Curaçao" },
    { value: "CY", label: "Cyprus" },
    { value: "CZ", label: "Czech Republic" },
    { value: "DK", label: "Denmark" },
    { value: "DJ", label: "Djibouti" },
    { value: "DM", label: "Dominica" },
    { value: "DO", label: "Dominican Republic" },
    { value: "EC", label: "Ecuador" },
    { value: "EG", label: "Egypt" },
    { value: "SV", label: "El Salvador" },
    { value: "GQ", label: "Equatorial Guinea" },
    { value: "ER", label: "Eritrea" },
    { value: "EE", label: "Estonia" },
    { value: "ET", label: "Ethiopia" },
    { value: "FK", label: "Falkland Islands (Malvinas)" },
    { value: "FO", label: "Faroe Islands" },
    { value: "FJ", label: "Fiji" },
    { value: "FI", label: "Finland" },
    { value: "FR", label: "France" },
    { value: "GF", label: "French Guiana" },
    { value: "PF", label: "French Polynesia" },
    { value: "TF", label: "French Southern Territories" },
    { value: "GA", label: "Gabon" },
    { value: "GM", label: "Gambia" },
    { value: "GE", label: "Georgia" },
    { value: "DE", label: "Germany" },
    { value: "GH", label: "Ghana" },
    { value: "GI", label: "Gibraltar" },
    { value: "GR", label: "Greece" },
    { value: "GL", label: "Greenland" },
    { value: "GD", label: "Grenada" },
    { value: "GP", label: "Guadeloupe" },
    { value: "GU", label: "Guam" },
    { value: "GT", label: "Guatemala" },
    { value: "GG", label: "Guernsey" },
    { value: "GN", label: "Guinea" },
    { value: "GW", label: "Guinea-Bissau" },
    { value: "GY", label: "Guyana" },
    { value: "HT", label: "Haiti" },
    { value: "HM", label: "Heard Island and McDonald Mcdonald Islands" },
    { value: "VA", label: "Holy See (Vatican City State)" },
    { value: "HN", label: "Honduras" },
    { value: "HK", label: "Hong Kong" },
    { value: "HU", label: "Hungary" },
    { value: "IS", label: "Iceland" },
    { value: "IN", label: "India" },
    { value: "ID", label: "Indonesia" },
    { value: "IR", label: "Iran, Islamic Republic of" },
    { value: "IQ", label: "Iraq" },
    { value: "IE", label: "Ireland" },
    { value: "IM", label: "Isle of Man" },
    { value: "IL", label: "Israel" },
    { value: "IT", label: "Italy" },
    { value: "JM", label: "Jamaica" },
    { value: "JP", label: "Japan" },
    { value: "JE", label: "Jersey" },
    { value: "JO", label: "Jordan" },
    { value: "KZ", label: "Kazakhstan" },
    { value: "KE", label: "Kenya" },
    { value: "KI", label: "Kiribati" },
    { value: "KP", label: "Korea, Democratic People's Republic of" },
    { value: "KR", label: "Korea, Republic of" },
    { value: "KW", label: "Kuwait" },
    { value: "KG", label: "Kyrgyzstan" },
    { value: "LA", label: "Lao People's Democratic Republic" },
    { value: "LV", label: "Latvia" },
    { value: "LB", label: "Lebanon" },
    { value: "LS", label: "Lesotho" },
    { value: "LR", label: "Liberia" },
    { value: "LY", label: "Libya" },
    { value: "LI", label: "Liechtenstein" },
    { value: "LT", label: "Lithuania" },
    { value: "LU", label: "Luxembourg" },
    { value: "MO", label: "Macao" },
    { value: "MK", label: "Macedonia, the Former Yugoslav Republic of" },
    { value: "MG", label: "Madagascar" },
    { value: "MW", label: "Malawi" },
    { value: "MY", label: "Malaysia" },
    { value: "MV", label: "Maldives" },
    { value: "ML", label: "Mali" },
    { value: "MT", label: "Malta" },
    { value: "MH", label: "Marshall Islands" },
    { value: "MQ", label: "Martinique" },
    { value: "MR", label: "Mauritania" },
    { value: "MU", label: "Mauritius" },
    { value: "YT", label: "Mayotte" },
    { value: "MX", label: "Mexico" },
    { value: "FM", label: "Micronesia, Federated States of" },
    { value: "MD", label: "Moldova, Republic of" },
    { value: "MC", label: "Monaco" },
    { value: "MN", label: "Mongolia" },
    { value: "ME", label: "Montenegro" },
    { value: "MS", label: "Montserrat" },
    { value: "MA", label: "Morocco" },
    { value: "MZ", label: "Mozambique" },
    { value: "MM", label: "Myanmar" },
    { value: "NA", label: "Namibia" },
    { value: "NR", label: "Nauru" },
    { value: "NP", label: "Nepal" },
    { value: "NL", label: "Netherlands" },
    { value: "NC", label: "New Caledonia" },
    { value: "NZ", label: "New Zealand" },
    { value: "NI", label: "Nicaragua" },
    { value: "NE", label: "Niger" },
    { value: "NG", label: "Nigeria" },
    { value: "NU", label: "Niue" },
    { value: "NF", label: "Norfolk Island" },
    { value: "MP", label: "Northern Mariana Islands" },
    { value: "NO", label: "Norway" },
    { value: "OM", label: "Oman" },
    { value: "PK", label: "Pakistan" },
    { value: "PW", label: "Palau" },
    { value: "PS", label: "Palestine, State of" },
    { value: "PA", label: "Panama" },
    { value: "PG", label: "Papua New Guinea" },
    { value: "PY", label: "Paraguay" },
    { value: "PE", label: "Peru" },
    { value: "PH", label: "Philippines" },
    { value: "PN", label: "Pitcairn" },
    { value: "PL", label: "Poland" },
    { value: "PT", label: "Portugal" },
    { value: "PR", label: "Puerto Rico" },
    { value: "QA", label: "Qatar" },
    { value: "RE", label: "Réunion" },
    { value: "RO", label: "Romania" },
    { value: "RU", label: "Russian Federation" },
    { value: "RW", label: "Rwanda" },
    { value: "BL", label: "Saint Barthélemy" },
    { value: "SH", label: "Saint Helena, Ascension and Tristan da Cunha" },
    { value: "KN", label: "Saint Kitts and Nevis" },
    { value: "LC", label: "Saint Lucia" },
    { value: "MF", label: "Saint Martin (French part)" },
    { value: "PM", label: "Saint Pierre and Miquelon" },
    { value: "VC", label: "Saint Vincent and the Grenadines" },
    { value: "WS", label: "Samoa" },
    { value: "SM", label: "San Marino" },
    { value: "ST", label: "Sao Tome and Principe" },
    { value: "SA", label: "Saudi Arabia" },
    { value: "SN", label: "Senegal" },
    { value: "RS", label: "Serbia" },
    { value: "SC", label: "Seychelles" },
    { value: "SL", label: "Sierra Leone" },
    { value: "SG", label: "Singapore" },
    { value: "SX", label: "Sint Maarten (Dutch part)" },
    { value: "SK", label: "Slovakia" },
    { value: "SI", label: "Slovenia" },
    { value: "SB", label: "Solomon Islands" },
    { value: "SO", label: "Somalia" },
    { value: "ZA", label: "South Africa" },
    { value: "GS", label: "South Georgia and the South Sandwich Islands" },
    { value: "SS", label: "South Sudan" },
    { value: "ES", label: "Spain" },
    { value: "LK", label: "Sri Lanka" },
    { value: "SD", label: "Sudan" },
    { value: "SR", label: "Suriname" },
    { value: "SJ", label: "Svalbard and Jan Mayen" },
    { value: "SZ", label: "Swaziland" },
    { value: "SE", label: "Sweden" },
    { value: "CH", label: "Switzerland" },
    { value: "SY", label: "Syrian Arab Republic" },
    { value: "TW", label: "Taiwan, Province of China" },
    { value: "TJ", label: "Tajikistan" },
    { value: "TZ", label: "Tanzania, United Republic of" },
    { value: "TH", label: "Thailand" },
    { value: "TL", label: "Timor-Leste" },
    { value: "TG", label: "Togo" },
    { value: "TK", label: "Tokelau" },
    { value: "TO", label: "Tonga" },
    { value: "TT", label: "Trinidad and Tobago" },
    { value: "TN", label: "Tunisia" },
    { value: "TR", label: "Turkey" },
    { value: "TM", label: "Turkmenistan" },
    { value: "TC", label: "Turks and Caicos Islands" },
    { value: "TV", label: "Tuvalu" },
    { value: "UG", label: "Uganda" },
    { value: "UA", label: "Ukraine" },
    { value: "AE", label: "United Arab Emirates" },
    { value: "GB", label: "United Kingdom" },
    { value: "US", label: "United States" },
    { value: "UM", label: "United States Minor Outlying Islands" },
    { value: "UY", label: "Uruguay" },
    { value: "UZ", label: "Uzbekistan" },
    { value: "VU", label: "Vanuatu" },
    { value: "VE", label: "Venezuela, Bolivarian Republic of" },
    { value: "VN", label: "Viet Nam" },
    { value: "VG", label: "Virgin Islands, British" },
    { value: "VI", label: "Virgin Islands, U.S." },
    { value: "WF", label: "Wallis and Futuna" },
    { value: "EH", label: "Western Sahara" },
    { value: "YE", label: "Yemen" },
    { value: "ZM", label: "Zambia" },
    { value: "ZW", label: "Zimbabwe" },
];

const options_time_zone = [
    { value: "-12:00", label: "(GMT -12:00) Eniwetok, Kwajalein" },
    { value: "-11:00", label: "(GMT -11:00) Midway Island, Samoa" },
    { value: "-10:00", label: "(GMT -10:00) Hawaii" },
    { value: "-09:50", label: "(GMT -9:30) Taiohae" },
    { value: "-09:00", label: "(GMT -9:00) Alaska" },
    { value: "-08:00", label: "(GMT -8:00) Pacific Time (US &amp; Canada)" },
    { value: "-07:00", label: "(GMT -7:00) Mountain Time (US &amp; Canada)" },
    { value: "-06:00", label: "(GMT -6:00) Central Time (US &amp; Canada), Mexico City" },
    { value: "-05:00", label: "(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima" },
    { value: "-04:50", label: "(GMT -4:30) Caracas" },
    { value: "-04:00", label: "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz" },
    { value: "-03:50", label: "(GMT -3:30) Newfoundland" },
    { value: "-03:00", label: "(GMT -3:00) Brazil, Buenos Aires, Georgetown" },
    { value: "-02:00", label: "(GMT -2:00) Mid-Atlantic" },
    { label: "(GMT -1:00) Azores, Cape Verde Islands", value: "-01:00" },
    { label: "(GMT) Western Europe Time, London, Lisbon, Casablanca", value: "+00:00" },
    { label: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris", value: "+01:00" },
    { label: "(GMT +2:00) Kaliningrad, South Africa", value: "+02:00" },
    { label: "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg", value: "+03:00" },
    { label: "(GMT +3:30) Tehran", value: "+03:50" },
    { label: "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi", value: "+04:00" },
    { label: "(GMT +4:30) Kabul", value: "+04:50" },
    { label: "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent", value: "+05:00" },
    { label: "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi", value: "+05:50" },
    { label: "(GMT +5:45) Kathmandu, Pokhara", value: "+05:75" },
    { label: "(GMT +6:00) Almaty, Dhaka, Colombo", value: "+06:00" },
    { label: "(GMT +6:30) Yangon, Mandalay", value: "+06:50" },
    { label: "(GMT +7:00) Bangkok, Hanoi, Jakarta", value: "+07:00" },
    { label: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong", value: "+08:00" },
    { label: "(GMT +8:45) Eucla", value: "+08:75" },
    { label: "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk", value: "+09:00" },
    { label: "(GMT +9:30) Adelaide, Darwin", value: "+09:50" },
    { label: "(GMT +10:00) Eastern Australia, Guam, Vladivostok", value: "+10:00" },
    { label: "(GMT +10:30) Lord Howe Island", value: "+10:50" },
    { label: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia", value: "+11:00" },
    { label: "(GMT +11:30) Norfolk Island", value: "+11:50" },
    { label: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka", value: "+12:00" },
    { label: "(GMT +12:45) Chatham Islands", value: "+12:75" },
    { label: "(GMT +13:00) Apia, Nukualofa", value: "+13:00" },
    { label: "(GMT +14:00) Line Islands, Tokelau", value: "+14:00" },
];

export {
    security_key,
    themeDefault,
    namesOfModes,
    options_patient,
    options_provider,
    options_label,
    options_status,
    options_city,
    options_state,
    BASE_URL,
    loadCityOptions,
    loadZipOptions,
    // imageBaseUrl,
};
